import PropTypes from 'prop-types';

import React from 'react';
import { Map } from 'immutable';

import TextBlock from '../../TextBlock';

import Wrapper from './Wrapper';

function Text(props) {
  return (
    <Wrapper>
      <TextBlock
        block={props.block}
        placeholder="Добавьте текст новости"
        maxLength={props.postType === 'short' ? 250 : 0}
        autoFocus
        onChange={props.onChangeBlockField}
      />
    </Wrapper>
  );
}

Text.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
  postType: PropTypes.oneOf(['short', 'longread']),

  onChangeBlockField: PropTypes.func,
};

export default Text;
